import { ILRSectionProps } from "./LRSection";

export const View = (props: ILRSectionProps) => {
  return (
    <div
      className={`lr-bg flex-container row align-items--center ${props.className}`}
    >
      <div className="left">{props.leftText}</div>
      <div className="right">{props.rightText}</div>
    </div>
  );
};
